module.exports = __webpack_public_path__ + "static/media/bandera_mexico.b0daaab4.png";